<section class="admin-studio">
  <header class="studio-heading">
    <div>
      <p class="eyebrow">CUSTOMER ADMINISTRATION</p>
      <h1>Centro de configuraci&oacute;n y gobierno</h1>
      <p class="lead">Administra el tenant, configura cada m&oacute;dulo de DeskPlus One y controla las capacidades transversales de tu organizaci&oacute;n.</p>
    </div>
    <div class="heading-actions">
      <a class="button button--secondary" routerLink="/app/admin/templates">
        <app-shell-icon name="document"></app-shell-icon>
        Centro de plantillas
      </a>
      <a class="button button--primary" routerLink="/app/admin/tenant">
        <app-shell-icon name="settings"></app-shell-icon>
        Configurar tenant
      </a>
    </div>
  </header>

  <section class="control-banner">
    <div class="banner-copy">
      <span class="banner-kicker">CONFIGURATION STUDIO</span>
      <h2>Configura c&oacute;mo opera DeskPlus One. La operaci&oacute;n diaria vive en los portales de Servicios y T&eacute;cnicos.</h2>
      <p>Estados, cat&aacute;logos, formularios, reglas, plantillas, infraestructura, activos, proyectos, contratos, calendarios, seguridad e integraciones se gobiernan desde aqu&iacute;.</p>
    </div>
    <div class="banner-actions">
      <a routerLink="/app/admin/modules"><app-shell-icon name="modules"></app-shell-icon><span><strong>M&oacute;dulos DeskPlus</strong><small>Features y capacidades habilitadas</small></span><b>&rarr;</b></a>
      <a routerLink="/app/admin/governance"><app-shell-icon name="governance"></app-shell-icon><span><strong>Gobierno</strong><small>Pol&iacute;ticas, control y trazabilidad</small></span><b>&rarr;</b></a>
    </div>
  </section>

  <section class="studio-section">
    <div class="section-heading">
      <div><span>CONFIGURACI&Oacute;N DE M&Oacute;DULOS</span><h2>Centros de configuraci&oacute;n</h2></div>
      <p>Cada centro concentra cat&aacute;logos, estados, reglas, plantillas y par&aacute;metros del dominio.</p>
    </div>

    <div class="domain-grid">
      <a class="domain-card" routerLink="/app/admin/service-management">
        <span class="domain-icon blue"><app-shell-icon name="catalog"></app-shell-icon></span>
        <div><strong>Service Management</strong><p>Cat&aacute;logo, incidentes, solicitudes, problemas, cambios, releases, prioridades, estados, motivos y grupos.</p></div>
        <b>&rarr;</b>
      </a>
      <a class="domain-card" routerLink="/app/admin/assets">
        <span class="domain-icon green"><app-shell-icon name="asset"></app-shell-icon></span>
        <div><strong>Activos e inventario</strong><p>Clases, tipos, perfiles, estados, fabricantes, modelos, ubicaciones, garant&iacute;as, movimientos, activo fijo y UEM.</p></div>
        <b>&rarr;</b>
      </a>
      <a class="domain-card" routerLink="/app/admin/infrastructure">
        <span class="domain-icon cyan"><app-shell-icon name="settings"></app-shell-icon></span>
        <div><strong>CMDB e infraestructura</strong><p>Tipos de CI, relaciones, redes, servidores, virtualizaci&oacute;n, cloud, VPN, topolog&iacute;a, Vault y conexiones.</p></div>
        <b>&rarr;</b>
      </a>
      <a class="domain-card" routerLink="/app/admin/projects">
        <span class="domain-icon rose"><app-shell-icon name="project"></app-shell-icon></span>
        <div><strong>Proyectos</strong><p>Tipos, estados, metodolog&iacute;as, fases, work items, riesgos, recursos, costos, Gantt, Kanban y portfolio.</p></div>
        <b>&rarr;</b>
      </a>
      <a class="domain-card" routerLink="/app/admin/contracts">
        <span class="domain-icon amber"><app-shell-icon name="contracts"></app-shell-icon></span>
        <div><strong>Contratos y proveedores</strong><p>Tipos, estados, renovaciones, bajas, evaluaciones, SLA contractual, compras, cotizaciones y alertas.</p></div>
        <b>&rarr;</b>
      </a>
      <a class="domain-card" routerLink="/app/admin/knowledge">
        <span class="domain-icon violet"><app-shell-icon name="knowledge"></app-shell-icon></span>
        <div><strong>Conocimiento y documentos</strong><p>Categor&iacute;as, tipos documentales, publicaci&oacute;n, revisi&oacute;n, versionado, retenci&oacute;n, procedimientos y recursos.</p></div>
        <b>&rarr;</b>
      </a>
      <a class="domain-card" routerLink="/app/admin/calendar">
        <span class="domain-icon blue"><app-shell-icon name="calendar"></app-shell-icon></span>
        <div><strong>Calendario y scheduling</strong><p>Tipos de evento, calendarios, horarios, recurrencia, recursos, recordatorios, Outlook y Google Calendar.</p></div>
        <b>&rarr;</b>
      </a>
      <a class="domain-card" routerLink="/app/admin/remote-support">
        <span class="domain-icon red"><app-shell-icon name="support"></app-shell-icon></span>
        <div><strong>Remote Support</strong><p>Pol&iacute;ticas, consentimiento, permisos, sesi&oacute;n, grabaci&oacute;n, transferencia, RDP, SSH, VNC y Remote Assist.</p></div>
        <b>&rarr;</b>
      </a>
    </div>
  </section>

  <section class="studio-section">
    <div class="section-heading">
      <div><span>MOTORES TRANSVERSALES</span><h2>Configuraci&oacute;n reutilizable</h2></div>
      <p>Estos motores son compartidos por todos los m&oacute;dulos y se versionar&aacute;n antes de publicarse.</p>
    </div>

    <div class="engine-grid">
      <a routerLink="/app/admin/service-management/forms"><span class="engine-icon"><app-shell-icon name="document"></app-shell-icon></span><div><strong>Formularios</strong><small>Campos, validaciones, reglas condicionales y versiones.</small></div><b>&rarr;</b></a>
      <a routerLink="/app/admin/service-management/approvals"><span class="engine-icon"><app-shell-icon name="workflow"></app-shell-icon></span><div><strong>Workflows y aprobaciones</strong><small>Estados, transiciones, niveles y decisiones.</small></div><b>&rarr;</b></a>
      <a routerLink="/app/admin/service-management/sla"><span class="engine-icon"><app-shell-icon name="calendar"></app-shell-icon></span><div><strong>SLA y OLA</strong><small>Objetivos, calendarios, pausas y escalamiento.</small></div><b>&rarr;</b></a>
      <a routerLink="/app/admin/automation"><span class="engine-icon"><app-shell-icon name="automation"></app-shell-icon></span><div><strong>Automatizaci&oacute;n</strong><small>Triggers, condiciones, acciones y simulaci&oacute;n.</small></div><b>&rarr;</b></a>
      <a routerLink="/app/admin/templates"><span class="engine-icon"><app-shell-icon name="document"></app-shell-icon></span><div><strong>Centro de plantillas</strong><small>Correos, contratos, actas, bajas, entregas y documentos.</small></div><b>&rarr;</b></a>
      <a routerLink="/app/admin/notifications"><span class="engine-icon"><app-shell-icon name="notifications"></app-shell-icon></span><div><strong>Notificaciones</strong><small>Eventos, canales, remitentes, reglas y proveedores.</small></div><b>&rarr;</b></a>
      <a routerLink="/app/admin/surveys"><span class="engine-icon"><app-shell-icon name="surveys"></app-shell-icon></span><div><strong>Encuestas</strong><small>Plantillas, preguntas, escalas y disparadores.</small></div><b>&rarr;</b></a>
      <a routerLink="/app/admin/integrations"><span class="engine-icon"><app-shell-icon name="integrations"></app-shell-icon></span><div><strong>Integraciones</strong><small>M365, Entra, Google, correo, APIs, webhooks y ERP.</small></div><b>&rarr;</b></a>
    </div>
  </section>

  <section class="admin-foundation">
    <article class="foundation-panel">
      <header><div><span>ADMINISTRACI&Oacute;N BASE</span><h2>Tenant y plataforma</h2></div></header>
      <div class="foundation-grid">
        <a routerLink="/app/admin/tenant"><app-shell-icon name="organization"></app-shell-icon><span><strong>Tenant y organizaci&oacute;n</strong><small>Empresa, sedes, unidades, ubicaciones, pa&iacute;s, idioma, moneda, dominios y branding.</small></span><b>&rarr;</b></a>
        <a routerLink="/app/admin/people"><app-shell-icon name="users"></app-shell-icon><span><strong>Personas y acceso</strong><small>Usuarios, membres&iacute;as, equipos y estructura organizacional.</small></span><b>&rarr;</b></a>
        <a routerLink="/app/admin/access"><app-shell-icon name="shield"></app-shell-icon><span><strong>Roles y permisos</strong><small>Operaciones, alcances, condiciones y responsabilidades.</small></span><b>&rarr;</b></a>
        <a routerLink="/app/admin/modules"><app-shell-icon name="modules"></app-shell-icon><span><strong>Centro de m&oacute;dulos</strong><small>Entitlements, features contratados y capacidades habilitadas.</small></span><b>&rarr;</b></a>
      </div>
    </article>

    <article class="foundation-panel governance-panel">
      <header><div><span>PLATAFORMA Y GOBIERNO</span><h2>Control empresarial</h2></div></header>
      <div class="foundation-grid compact">
        <a routerLink="/app/admin/email"><app-shell-icon name="email"></app-shell-icon><span><strong>Correo e identidad</strong><small>Remitentes, dominios, autenticaci&oacute;n y SSO.</small></span><b>&rarr;</b></a>
        <a routerLink="/app/admin/security"><app-shell-icon name="shield"></app-shell-icon><span><strong>Seguridad y auditor&iacute;a</strong><small>Pol&iacute;ticas, sesiones, eventos y trazabilidad.</small></span><b>&rarr;</b></a>
        <a routerLink="/app/admin/governance"><app-shell-icon name="governance"></app-shell-icon><span><strong>Centro de gobierno</strong><small>Reglas corporativas, retenci&oacute;n y control.</small></span><b>&rarr;</b></a>
        <a routerLink="/app/admin/ai-governance"><app-shell-icon name="ai"></app-shell-icon><span><strong>Gobierno de IA</strong><small>Autonom&iacute;a, riesgo, confianza y aprobaci&oacute;n humana.</small></span><b>&rarr;</b></a>
      </div>
    </article>
  </section>

  <section class="account-strip">
    <div><span>MI CUENTA DESKPLUS</span><strong>Suscripci&oacute;n, licencias, facturaci&oacute;n y soporte de la plataforma.</strong></div>
    <nav>
      <a routerLink="/app/admin/subscription">Plan y suscripci&oacute;n</a>
      <a routerLink="/app/admin/billing">Facturas y pagos</a>
      <a routerLink="/app/admin/niotech-support">Soporte NIOTECH</a>
    </nav>
  </section>
</section>
